export default "__VITE_ASSET__ChfI03d6__"